import { getApiBaseUrl } from "src/utils";

export const getFoodicsInstallUrl = (companyId: number): string | null => {
  const base = getApiBaseUrl();
  if (!base) {
    return null;
  }
  return `${base}/api/foodics/install?company_id=${encodeURIComponent(companyId)}`;
};
